import { WrapImsPacket } from '../../../store/utility';
import axiosInstance from '../../../services/axios/axios';

/**
 * Submit an SSH Exception
 */
export const SubmitSSHExceptionRequest = async exceptionArgs => {
	try {
		return await axiosInstance.post(
			`api/SSHException/Submission`,
			WrapImsPacket(exceptionArgs)
		);
	} catch (ex) {
		console.error('Unable to submit exception: ' + ex);

		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Search for Person
 */
export const fetchPersonSearch = async payload => {
	try {
		return await axiosInstance.post(`api/Components/PersonSearch`, payload);
	} catch (ex) {
		console.error('Unable to fetch person search: ' + ex);

		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};
